import { CommonProps } from 'types/common/PropsTypes';

// { addClassName }는 생길일 있으면 추가
const ModalBodyLayout = ({ children }: CommonProps) => {
  return <div className="modal-body row">{children}</div>;
};

export default ModalBodyLayout;
